import ReactDOM from "react-dom/client";
import { IconButton } from "@mui/material";
import { SnackbarProvider, closeSnackbar } from "notistack";
import { GridCloseIcon } from "@mui/x-data-grid-pro";
import App from "./App";
import "./index.css";
import "./styles/dx-brand-overrides.css";
import { getAppBrand } from "./config/resolve-app-brand";
import { applyBrandCssVars } from "./utils/themes/apply-brand-css-vars";
import { applyBrandFavicon } from "./utils/themes/apply-brand-favicon";
import { getInitialDarkMode } from "./utils/themes/get-initial-dark-mode";

const appBrand = getAppBrand();
const initialDarkMode = getInitialDarkMode();
applyBrandCssVars(appBrand, initialDarkMode);
applyBrandFavicon(appBrand, initialDarkMode);

const action = (key) => (
  <IconButton
    size="small"
    aria-label="close"
    color="inherit"
    onClick={() => closeSnackbar(key)}
    data-testid="src--IconButton-0">
    <GridCloseIcon fontSize="small" />
  </IconButton>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SnackbarProvider maxSnack={8} action={action} autoHideDuration={6000}>
    <App />
  </SnackbarProvider>
);
